export const environment = {
  production: false,
  name: 'shipa',
  backendlessAPI:
    'https://api.testship.net/9054AC56-9E4E-646C-FF2F-6DEB2FE02300/F9F7681E-24D6-4167-AC40-23A855CDA0C0/services',
};
